/*  ==========================================================================
    CONTENTCLUSTER LIST VIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';
import objectFitImages from 'object-fit-images';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

// callback function
function callbackCcListView(container) {

    // object fit fix for older browsers (especially ie11)
    let images = $(container).find('img');
    objectFitImages(images, {
        watchMQ: true
    });

    // subtype slider
    if($(container).hasClass('bn-cc-list-view__type-slider')) {

        // slider initialization
        let sliderOverrides = {
                adaptiveHeight: true,
                autoplay: false,
                dots: false,
                fade: false,
                nextArrow: vars.slick_nextArrowV2,
                pauseOnHover: true,
                prevArrow: vars.slick_prevArrowV2,
            };
        utils.slickCarousel.initSingleSlider(container, sliderOverrides);

    }

    // subtype list
    if($(container).hasClass('bn-cc-list-view__type-list')) {

        // pagination
        let $listPagiantion = $(container).find('.bn-cc-list-view__pagination'),
            $listPagiantionTrigger = $listPagiantion.find('.bn-button');
        if($listPagiantion.length) {
            let offset = $listPagiantionTrigger.data('offset');
            $(container).data('cc_query-offset', offset);
            $listPagiantionTrigger.on('click', function() {
                $listPagiantion.remove();
                $(container).find('.bn-loader').removeClass('hidden');
                utils.contentclusterLoader.initCcService(container,callbackCcListView);
            });
        }

    }

}

// initialization
export function initCcListView($element) {
    let container = $element.find('.cc-service');

    // contentcluster service initialization (if element is in view)
    $element.one('inview', function() {
        utils.contentclusterLoader.initCcService(container,callbackCcListView);
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/cc-list-view.js